<script type="ts">
  import { link } from 'svelte-spa-router';

  export let user: { name: string; url?: string };
</script>

{#if user}
  {#if user.url}
    <a href={user.url} use:link>{user.name}</a>
  {:else}
    <p>{user.name}</p>
  {/if}
{/if}
